export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./colorContrast.vue?vue&type=template&id=fc0760d8&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Settings/colorContrast.vue?vue&type=template&id=fc0760d8&
// module id = null
// module chunks = 